import { Section } from 'components/section'
import { Heading } from 'components/heading'
import { Accordion, AccordionThemeClasses } from 'components/accordion'
import { Markdown } from 'components/markdown'
import { IThingsToKnowData } from 'api/strapi/thingsToKnow/types'

import classes from './things-to-know.module.css'
import styles from './accordion.module.css'

const ACCORDION_CLASSES: AccordionThemeClasses = {
  itemNumber: styles.itemNumber,
  item: styles.accordionItem,
  trigger: styles.accordionTrigger,
}

interface IThingsToKnowProps {
  thingsToKnow: IThingsToKnowData[]
}

export const ThingsToKnow = ({ thingsToKnow }: IThingsToKnowProps) => {
  return (
    <Section className={classes.section}>
      <Heading component="h2" theme="h2" className={classes.title}>
        {thingsToKnow.length || ''} things to know about Home Price Protection when selling a house
      </Heading>
      <ul className={styles.list}>
        {thingsToKnow.map((item, idx) => (
          <li className={styles.item} key={item.id}>
            <Accordion title={item.title} classes={ACCORDION_CLASSES} index={idx}>
              <Markdown className={styles.content}>{item.content}</Markdown>
            </Accordion>
          </li>
        ))}
      </ul>
    </Section>
  )
}
